/**
 * Axolotea Header Scroll Behavior
 * Hides header on scroll down, shows on scroll up
 */

class AxoloteaHeader {
  constructor() {
    this.header = document.querySelector('.header-wrapper');
    this.hero = document.querySelector('.axolotea-hero');
    this.lastScroll = 0;
    this.scrollThreshold = 100; // Pixels to scroll before hiding

    if (!this.header) return;

    this.init();
  }

  init() {
    // Add smooth transition
    this.header.style.transition = 'transform 0.3s ease-in-out';

    // Listen to scroll events
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  handleScroll() {
    const currentScroll = window.pageYOffset;

    // Check if hero is visible in viewport
    if (this.hero) {
      const heroRect = this.hero.getBoundingClientRect();
      const heroVisible = heroRect.bottom > 0; // Hero is visible if bottom is below top of viewport

      if (heroVisible) {
        this.header.classList.remove('header-scrolled');
      } else {
        this.header.classList.add('header-scrolled');
      }
    }

    // Don't hide if at top of page
    if (currentScroll <= this.scrollThreshold) {
      this.showHeader();
      this.lastScroll = currentScroll;
      return;
    }

    // Scrolling down - hide header
    if (currentScroll > this.lastScroll && currentScroll > this.scrollThreshold) {
      this.hideHeader();
    }
    // Scrolling up - show header
    else if (currentScroll < this.lastScroll) {
      this.showHeader();
    }

    this.lastScroll = currentScroll;
  }

  hideHeader() {
    this.header.style.transform = 'translateY(-100%)';
    this.header.classList.add('header-hidden');
  }

  showHeader() {
    this.header.style.transform = 'translateY(0)';
    this.header.classList.remove('header-hidden');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AxoloteaHeader();
  });
} else {
  new AxoloteaHeader();
}
